<label class="br-form-label" for="density-radius">Radius · {{ feature.settings.radius }} px</label>
<input id="density-radius" type="range" min="8" max="96" step="1"
       [ngModel]="feature.settings.radius" (ngModelChange)="feature.update({radius: $event})">
<label class="br-form-label br-mt-2" for="density-blur">Blur · {{ feature.settings.blur }} px</label>
<input id="density-blur" type="range" min="0" max="64" step="1"
       [ngModel]="feature.settings.blur" (ngModelChange)="feature.update({blur: $event})">
<label class="br-form-label br-mt-2" for="density-opacity">Opacity · {{ feature.settings.opacity }}%</label>
<input id="density-opacity" type="range" min="10" max="100" step="5"
       [ngModel]="feature.settings.opacity" (ngModelChange)="feature.update({opacity: $event})">
<label class="br-form-label br-mt-2" for="density-contrast">Contrast</label>
<input id="density-contrast" type="range" min="0.25" max="4" step="0.25"
       [ngModel]="feature.settings.contrast" (ngModelChange)="feature.update({contrast: $event})">
<label id="density-colormap-label" class="br-form-label br-mt-2">Colormap</label>
<mat-select id="density-colormap" class="br-form-control" aria-labelledby="density-colormap-label" [ngModel]="feature.settings.colormap"
        (ngModelChange)="feature.update({colormap: $event})">
  <mat-option *ngFor="let colormap of colormaps" [value]="colormap.value">{{ colormap.label }}</mat-option>
</mat-select>
<button type="button" class="br-btn br-btn--secondary br-btn--sm br-mt-3" (click)="feature.reset()">Reset</button>
